export enum SurveyEndStatus {
    COMPLETE = 'COMPLETE',
    HONORARIA_ONLY = 'HONORARIA ONLY',
    SCREEN = 'SCREEN',
    PART = 'PART',
}
